<template>
    <div id="clients-page">
        <confirm :disabled="!isCorrect || deleteLoading" buttonClass="btn-danger" id="confirmClientDeletion" ref="confirmClientDeletion"
             @confirm="deleteClients">
            <template slot="title">
                <span>{{ t('clientsDeletion-last_step_confirm') }} <strong class="text-danger"> {{ t('clientsDeletion-last_step_irreversible') }}</strong></span>
            </template>
            <template slot="body">
                <div>
                    <deletion-info class="mb-3" />
                    <confirm-phrase v-model="isCorrect" :placeholderText="placeholderText" />
                </div>
            </template>
        </confirm>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <loader v-if="is('loading')"></loader>
                    <div class="d-flex justify-content-between">
                        <h1>{{ t('clientsDeletion-title') }}</h1>
                    </div>
                    <filter-bar
                        @changed="updateStats"
                        ref="filter-bar"
                        :update-query-string="true"
                        :has-period-filter="false"
                        :has-client-filter="false"
                        :has-form-filter="false"
                        :has-branch-filter="false"
                        :filters="extraFiltersClients"
                        :show-labels="true" />
                    <div v-show="is('loaded')">

                        <div class="clearfix" v-show="stats.total > 0">

                            <total-stats :stats="stats" />
                            <clients-by-branch :stats="stats" />


                            <div v-if="!howToDeleteClicked" class="w-100 d-flex justify-content-center">
                                <span>
                                    {{ t('clientsDeletion-start_deletion_text') }} <u class="text-danger"><strong
                                        role="button"  @click="beginProcess('deletion-info')"> {{ t('clientsDeletion-click_here') }}</strong></u>.
                                </span>
                            </div>

                            <div v-show="howToDeleteClicked">

                                <deletion-info id="deletion-info" class="my-3" />

                                <h2 class="text-uppercase my-4">{{ t('clientsDeletion-step1_title') }}</h2>

                                <div class="filter-section">
                                    <FilterBar @changed="updateUnsubmitedFilters" ref="filter-bar"
                                        :update-query-string="false"
                                               :has-period-filter="false"
                                               :has-client-filter="false"
                                               :has-form-filter="false"
                                               :has-branch-filter="true"
                                               :is-vertical="true"
                                               :filters="extraFilters"
                                        :show-labels="true" />
                                    <button @click="openStepTwo()" class="filter add-filter mb-2">
                                        {{ t('clientsDeletion-apply_filters') }}</button>
                                </div>

                                <h2 v-show="openStepTwoClicked" class="text-uppercase my-4">{{ t('clientsDeletion-step2_title') }}</h2>
                                <grid id="clients-grid" v-show="openStepTwoClicked" @loaded="dataLoaded" :showSearch="false"
                                    source="clients/estimate-to-delete" :filters="filters">

                                    <template v-slot:rows="grid">
                                        <thead>
                                            <tr>
                                                <grid-th :grid="grid" :sortable="true" attr="name">{{ t('clientsDeletion-col_name') }}</grid-th>
                                                <grid-th :grid="grid" :sortable="true" attr="whatsapp">{{ t('clientsDeletion-col_phone') }}</grid-th>
                                                <grid-th :grid="grid" :sortable="true" attr="birthdate"
                                                    class="col-center">{{ t('clientsDeletion-col_birthday') }}</grid-th>

                                                <grid-th :grid="grid" :sortable="true" attr="average_value"
                                                    class="col-center">{{ t('clientsDeletion-col_avg_ticket') }}</grid-th>
                                                <grid-th :grid="grid" :sortable="true" attr="total_value"
                                                    class="col-center">{{ t('clientsDeletion-col_total_spent') }}</grid-th>


                                                <grid-th :grid="grid" :sortable="true" attr="email">{{ t('clientsDeletion-col_email') }}</grid-th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="cursor: pointer" v-for="client in grid.data" :key="client.id" @click="
                                                $router.push(
                                                    '/client/' +
                                                    client.id,
                                                )
                                                ">
                                                <td style="min-width: 250px">
                                                    {{ client.first_name }}
                                                    {{ client.last_name }}
                                                </td>
                                                <td style="min-width: 160px">
                                                    <btn-whatsapp :number="client.whatsapp"></btn-whatsapp>
                                                    {{ client.whatsapp }}
                                                </td>
                                                <td style="min-width: 160px" class="col-center">
                                                    <template v-if="client.birthdate">
                                                        <human-date :date="client.birthdate" :format="t('dates-format_date')" />
                                                        ({{
                                                            calculateAge(
                                                                client.birthdate,
                                                            )
                                                        }}
                                                        anos)
                                                    </template>
                                                    <span v-else>{{ t('clientsDeletion-birthday_not_set') }}</span>
                                                </td>


                                                <td style="min-width: 170px" class="col-center">
                                                    {{ currencySymbol }} {{ client.average_value }}
                                                </td>
                                                <td style="min-width: 130px" class="col-center">
                                                    {{ currencySymbol }} {{ client.total_value }}
                                                </td>
                                                <td style="min-width: 220px">
                                                    {{ client.email }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                    <template v-slot:list="grid">
                                        <div class="item" v-for="client in grid.data" :key="client.clients_id">
                                            <span class="info title">
                                                {{ client.first_name }}
                                                {{ client.last_name }}
                                            </span>
                                            <span class="info">
                                                <span class="pull-left">{{ client.whatsapp }}
                                                </span>
                                                <btn-whatsapp :number="client.whatsapp"></btn-whatsapp>
                                            </span>
                                            <div class="clear"></div>
                                            <span class="info">
                                                {{ client.email }}
                                            </span>
                                            <button class="btn btn-sm btn-primary" @click="
                                                $router.push(
                                                    'client/' +
                                                    client.clients_id,
                                                )
                                                ">
                                                {{ t('clientsDeletion-details_button') }}
                                            </button>
                                        </div>
                                    </template>
                                </grid>
                                <div>
                                    <div v-show="openStepTwoClicked" class="row stats text-center mx-2">
                                        <h2 class="text-uppercase my-4">{{ t('clientsDeletion-step3_title') }}</h2>

                                        <div class="col-12 ">
                                            <div class="row ">
                                                <div class="col-sm-12 col-md-4">
                                                    <div class="box">
                                                        <div class="info ">
                                                            <div class="label">
                                                                <strong>{{ t('clientsDeletion-clients_now') }}</strong>
                                                            </div>
                                                            <div class="number">
                                                                {{ stats.total }}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 col-md-4">
                                                    <div class="box">
                                                        <div class="info">
                                                            <div class="label">
                                                                <strong>{{ t('clientsDeletion-selected_for_removal') }}</strong>
                                                            </div>
                                                            <div class="number">
                                                                {{ total }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 col-md-4">
                                                    <div class="box">
                                                        <div class="info">
                                                            <div class="label">
                                                                <strong>{{ t('clientsDeletion-remaining_after_removal') }}</strong>
                                                            </div>
                                                            <div class="number">
                                                                {{
                                                                    totalAfterDelete }}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <button @click="confirmDelete" class="btn btn-danger mb-2 ml-3">
                                            {{ total === 1 ? t('clientsDeletion-delete_button_singular', [total]) : t('clientsDeletion-delete_button', [total]) }}</button>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="clearfix" v-if="stats.totalClients == 0">
                            <div class="box">
                                <h1>{{ t('clientsDeletion-total_stats-clients') }}</h1>
                                <h2>
                                    {{ t('clientsDeletion-no_clients') }}
                                </h2>
                                <div v-if="user.global_admin">
                                    <importOrders v-if="user.global_admin" />
                                    <br />
                                    <importClients v-if="user.global_admin" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import FilterBar from "../components/reports/filter-bar";
import keviApi from "../keviApi.js";
import HumanDate from "../components/human-date/human-date";
import totalStats from "./total-stats.vue";
import clientsByBranch from "./clients-by-branch.vue";
import deletionInfo from "./deletion-info.vue";
import confirmPhrase from "../components/inputs/confirm-phrase.vue";

export default {
    components: {
        HumanDate,
        FilterBar,
        totalStats,
        clientsByBranch,
        deletionInfo,
        confirmPhrase
    },
    data: function () {
        return {
            state: "loading",
            stats: {
                data: [],
                total: 0
            },
            exporting: false,
            filters: {},
            unsubmitedFilters: {},
            grid: {},
            total: 0,
            totalAfterDelete: 0,
            isCorrect: false,
            howToDeleteClicked: false,
            openStepTwoClicked: false,
            placeholderText: "",
            extraFilters: [],
            extraFiltersClients: [],
            deleteLoading: false
        };
    },
    mounted() {
        this.resetFilters();
        this.updateStats();
        this.updateList();
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            this.t('clientsDeletion-page_title');
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        beginProcess(elementId) {
            this.howToDeleteClicked = true;
            setTimeout(() => {
                this.scrollToElement(elementId);
            }, 100);
        },
        scrollToElement(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        },
        deleteClients() {
            this.deleteLoading = true;
            const options = keviApi.getOptions("/clients/create-batch-to-delete", "POST", {
                filters: this.filters
            });
            this.$http(options).then((response) => {
                if (response.status === 201) {
                    this.$store.dispatch(
                        "notification/success",
                        this.t('clients-deletion-started'),
                    );
                    this.updateFilters({});
                    this.updateStats();
                    this.updateList();
                    this.isCorrect = false;
                    this.howToDeleteClicked = false;
                    this.openStepTwoClicked = false;
                    this.checkBoxToDelete = false;
                    this.openStepThreeClicked = false;
                }
                else {
                    this.$store.dispatch(
                        "notification/warning",
                        this.t('clients-deletion-error'),
                    );
                }
                this.deleteLoading = false;
            });
        },
        confirmDelete: function () {
            this.$refs.confirmClientDeletion.open();
        },
        openStepTwo() {
            this.openStepTwoClicked = true;
            this.updateFilters(this.unsubmitedFilters);
            setTimeout(() => {
                this.scrollToElement("clients-grid");
            }, 100);
        },
        dataLoaded(data) {
            this.userInput = "";
            this.total = data.total;
            this.totalAfterDelete = this.stats.total - this.total;
            const key = this.total == 1 ? 'clientsDeletion-confirm_phrase_placeholder_singular' : 'clientsDeletion-confirm_phrase_placeholder_plural';
            this.placeholderText = this.t(key, [this.total]);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        updateStats: function (filters) {
            this.setState("loading");

            const data = {};
            if (filters) {
                data.filters = filters;
            }
            let options = keviApi.getOptions(
                "clients/by-branch/list",
                "GET",
                data
            );

            this.$http(options).then((response) => {
                this.setState("loaded");
                if (response.status === 200) {
                    this.stats = response.body;
                }
            });
        },
        updateList: function () {
            let data = {
                filters: this.filters,
            };
            let options = keviApi.getOptions(
                "clients/estimate-to-delete",
                "GET",
                data
            );

            this.$http(options).then(() => {});
        },
        updateUnsubmitedFilters(filters) {
            this.unsubmitedFilters = filters;
        },
        updateFilters: function (filters) {
            this.filters = filters;
            this.updateList();
        },
        resetFilters() {
            const filterBar = this.$refs["filter-bar"];
            if(!filterBar) {
                return;
            }
            filterBar.selectedFilters = [];
            filterBar.values = {};

            this.extraFilters = [];

            this.extraFilters.push({
                component: "min-max",
                label: this.$root.t('filter_bar-avg_ticket'),
                name: "avg-ticket",
                removable: true,
            });

            this.extraFilters.push({
                component: "min-max",
                label: this.$root.t('filter_bar-orders_amount'),
                name: "orders-amount",
                options: {
                    mask: "######",
                },
                removable: true,
            });

            this.extraFilters.push({
                component: "selectbox",
                label: this.$root.t('filter_bar-customer_profile'),
                name: "customer-profile",
                options: [
                    { value: "1", label: this.$root.t('filter_bar-with_complete_registration') },
                    { value: "0", label: this.$root.t('filter_bar-without_complete_registration') },
                ],
                removable: true,
            });

            this.extraFilters.push({
                component: "min-max",
                label: this.$root.t('filter_bar-points_balance'),
                name: "points-balance",
                options: {
                    mask: "######",
                },
                removable: true,
            });

            if (this.$module("segments")) {
                let options = keviApi.getOptions("segments");
                this.$http(options).then((response) => {
                    let segments = response.body;
                    this.extraFilters.push({
                        component: "checkbox",
                        label: this.$root.t('filter_bar-client_segments'),
                        name: "client-segments",
                        options: {
                            options: segments.map((seg) => ({
                                value: seg.id,
                                label: seg.name,
                            })),
                            icon: "fa-tag",
                        },
                        removable: true,
                    });
                    this.extraFiltersClients.push({
                        component: "checkbox",
                        label: this.$root.t('filter_bar-client_segments'),
                        name: "client-segments",
                        options: {
                            options: segments.map((seg) => ({
                                value: seg.id,
                                label: seg.name,
                            })),
                            icon: "fa-tag",
                        },
                        removable: true,
                    });
                });
            }

            this.extraFilters.push({
                component: "min-max-dates",
                label: this.$root.t('filter_bar-last_order_period'),
                name: "last-order-period",
                removable: true,
            });

            this.extraFilters.push({
                component: "period-between-execution",
                label: this.$root.t('filter_bar-min_period_between_executions'),
                name: "min-period-between-execution",
                removable: true,
            });

            if (this.$store.state.place.branches.length > 1) {
                this.extraFilters.push({
                    component: "branch",
                    label: this.$root.t('filter_bar-branches'),
                    removable: true,
                    name: "branch",
                });
            }

            if (this.$store.state.place.branches.length > 1) {
                this.extraFilters.push({
                    component: "branch",
                    label: this.$root.t('filter_bar-last_order_branch'),
                    removable: true,
                    name: "last_branch",
                });
            }

            if (
                this.trigger === "specific_date" ||
                this.trigger === "periodic"
            ) {
                this.extraFilters.push({
                    component: "number",
                    label: this.$root.t('filter_bar-clients_limit'),
                    name: "clients-limit",
                    options: {
                        mask: "######",
                        label: this.$root.t('filter_bar-value'),
                    },
                    removable: true,
                });
            }
        },
        calculateAge: function (birthday) {
            birthday = new Date(birthday);
            let ageDifMs = Date.now() - birthday.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        },
    },
};
</script>

<style>
.grid .grid-header {
    margin: 0px 0px !important;
}
</style>
